import React, { Component } from 'react'
import Link from 'components/Link'
import PropTypes from 'prop-types'
import { Eyebrow } from 'components/Typography'
import { Container, Spacing50 } from 'styles/sharedStyle'
import GA4 from 'utils/GA4'

import {
  EventPromoWrapper,
  EventPromoImage,
  EventPromoInfo,
  EventPromoInfoDate,
  EventPromoInfoHeader,
  EventPromoInfoLabel,
} from './EventPromo.style'

class EventPromo extends Component {
  constructor(props) {
    super(props)

    this.months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]

    this.days = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ]
  }

  formatDate(eventRunStartDate, eventRunFinishDate) {
    const fullStartDate = new Date(eventRunStartDate)
    const fullEndDate = new Date(eventRunFinishDate)

    const startDate = {
      day: fullStartDate.getDate(),
      weekDay: fullStartDate.getDay(),
      month: fullStartDate.getMonth(),
    }

    const endDate = {
      day: fullEndDate.getDate(),
      weekDay: fullEndDate.getDay(),
      month: fullEndDate.getMonth(),
    }

    if (eventRunStartDate === eventRunFinishDate) {
      return `${this.days[startDate.weekDay]} ${startDate.day} ${
        this.months[startDate.month]
      }`
    }

    if (startDate.month === endDate.month) {
      return `${this.days[startDate.weekDay]} ${startDate.day} - ${
        this.days[endDate.weekDay]
      } ${endDate.day} ${this.months[endDate.month]}`
    }

    return `${this.days[startDate.weekDay]} ${startDate.day} ${
      this.months[startDate.month]
    } - ${this.days[endDate.weekDay]} ${endDate.day} ${
      this.months[endDate.month]
    }`
  }

  render() {
    const {
      eventImage,
      eventName,
      eventRunStartDate,
      eventRunFinishDate,
      moreInfoLabel,
      linkUrl,
      nodeLocale,
      villageSlug,
      villagePlaceholderImage,
    } = this.props

    const eventPromoImage =
      eventImage?.landscape?.gatsbyImageData ||
      villagePlaceholderImage?.landscape?.gatsbyImageData

    // Do not display event component if there is no image to show with it
    if (!eventPromoImage) {
      return null
    }

    return (
      <>
        <Spacing50 />
        <EventPromoWrapper
          as={Container}
          maxWidth={['none', null, 980]}
          onClick={() =>
            GA4('event_card_click', {
              headline: eventName,
              village_name: villageSlug,
            })
          }>
          <EventPromoImage
            image={eventPromoImage}
            alt={eventImage.altText || ''}
          />

          <EventPromoInfo>
            <Eyebrow>
              <EventPromoInfoLabel>{moreInfoLabel}</EventPromoInfoLabel>
              <EventPromoInfoDate>
                {nodeLocale === 'en'
                  ? this.formatDate(eventRunStartDate, eventRunFinishDate)
                  : `${eventRunStartDate} - ${eventRunFinishDate}`}
              </EventPromoInfoDate>
            </Eyebrow>
            <EventPromoInfoHeader>
              {linkUrl ? <Link to={linkUrl}>{eventName}</Link> : eventName}
            </EventPromoInfoHeader>
          </EventPromoInfo>
        </EventPromoWrapper>
        <Spacing50 />
      </>
    )
  }
}

EventPromo.propTypes = {
  eventImage: PropTypes.oneOfType([PropTypes.object]).isRequired,
  eventName: PropTypes.string.isRequired,
  eventRunStartDate: PropTypes.string.isRequired,
  eventRunFinishDate: PropTypes.string.isRequired,
  moreInfoLabel: PropTypes.string.isRequired,
  linkUrl: PropTypes.string,
  nodeLocale: PropTypes.string,
  villageSlug: PropTypes.string,
  villagePlaceholderImage: PropTypes.oneOfType([PropTypes.object]),
}

EventPromo.defaultProps = {
  linkUrl: '',
  nodeLocale: 'en',
  villageSlug: '',
  villagePlaceholderImage: null,
}

export default EventPromo
